import { z } from 'zod';

/**
 * Trimmed AIS vessel target from the BarentsWatch/Kystverket open feed
 * (spec 16). The API proxy never forwards the raw upstream payload — only
 * these fields, already filtered to targets seen within the last 10 min.
 * Situational awareness only: deliberately no CPA/TCPA/derived collision
 * fields (recorded no-alarms decision, plans/README.md).
 */
export const aisVessel = z.object({
  mmsi: z.number(),
  name: z.string().nullable(),
  lat: z.number(),
  lon: z.number(),
  sogKn: z.number().nullable(),
  cogDeg: z.number().nullable(),
  headingDeg: z.number().nullable(),
  /** Raw AIS ship-type code (0–99); the UI maps it to ~8 nb-NO labels. */
  shipType: z.number().nullable(),
  /** Epoch ms of the target's last reported position. */
  ts: z.number(),
});
export type AisVessel = z.infer<typeof aisVessel>;

export const aisResponse = z.object({
  vessels: z.array(aisVessel),
});
export type AisResponse = z.infer<typeof aisResponse>;
